import { put, select } from 'redux-saga/effects';
import { isJourneyPageValid, visibilitySelector } from 'ctm-selectors';
import { getPageRules } from './state_selectors';

/**
 * Validate all previous pages.
 *
 * @param {Object} journeySchemaModel - Instance of the class "PageSchemaModel" initialized with "page_schema.json".
 * @param {Object} currentPage - Current journey page.
 * @returns {?Object} The first journey page with an error otherwise null.
 */
export const validateAllPreviousPages = function* (journeySchemaModel, currentPage) {
    let firstPageWithError = null;
    const allPreviousPages = journeySchemaModel.getAllPreviousStepPages(currentPage.name);

    /**
     * Loop over and validate each page.
     * We can do this by dispatching an action, because the action is synchronous.
     */
    for (const journeyPage of allPreviousPages) {
        const { components, name } = journeyPage;
        if (components) {
            const visibility = yield select(visibilitySelector);
            const rules = yield select(getPageRules, name);
            yield put({
                type: 'VALIDATE_PAGE',
                pageName: name,
                visibility,
                rules,
                stateKey: 'vertical.quote'
            });
            const isValid = yield select(isJourneyPageValid, name);

            // Break loop and return the page with the error.
            if (!isValid) {
                firstPageWithError = journeyPage;
                break;
            }
        }
    }
    return firstPageWithError;
};
